// extracted by mini-css-extract-plugin
export var item = "BlogPostHeroTranslations-module--item--93b6c";
export var language = "BlogPostHeroTranslations-module--language--30bff";